import React from 'react';
import ReactTooltip from 'react-tooltip';
import { title } from './translations';

const PlayerStatsTableHeader = ({ titles }) => (
  <thead>
    <tr>
      <th></th>
      {titles.map(title => (
        <TooltipTitle key={title} titleString={title} />
      ))}
    </tr>
  </thead>
);

const TooltipTitle = ({ titleString }) => (
  <th className="stats-table__column-title condensed">
    <span data-tip={`${title(titleString.toLowerCase())}`}>{titleString}</span>
    <ReactTooltip place="top" type="dark" effect="float" />
  </th>
);

export default PlayerStatsTableHeader;
